import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Provider } from 'src/app/models/Provider';
import { ProviderReportResponse } from 'src/app/models/provider-report.model';

@Injectable({ providedIn: 'root' })
export class ProviderReportService {

  constructor(private http: HttpClient) {}

  getReport(startDate: string, endDate: string, providerId?: string): Observable<ProviderReportResponse> {
    let params = new HttpParams()
      .set('start_date', startDate)
      .set('end_date', endDate);

    if (providerId) {
      params = params.set('provider_id', providerId);
    }

    return this.http.get<ProviderReportResponse>(`${environment.apiUrl}/provider-report`, { params });
  }

  getProviders(): Observable<Provider[]> {
    return this.http.get<Provider[]>(`${environment.apiUrl}/provider-report/providers`);
  }
}
